import { render, staticRenderFns } from "./district.vue?vue&type=template&id=1853ff36"
import script from "./district.vue?vue&type=script&lang=js"
export * from "./district.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports